import { Link, useForm } from '@inertiajs/react'
import Layout from '../Layout'

interface User {
  id: number
  email_address: string
  role: string
}

interface Account {
  id: number
  name: string
  slug: string
}

interface Props {
  user: User
  available_roles: string[]
  account: Account
  validationErrors?: string[]
  permissions?: {
    can_manage_users: boolean
  }
}

const roleLabels: Record<string, string> = {
  super_admin: 'Super Admin',
  admin: 'Administrador',
  supervisor: 'Supervisor',
  facturador: 'Facturador',
}

export default function UsersEdit({ user, available_roles, account, validationErrors, permissions }: Props) {
  const { data, setData, put, processing, errors: formErrors } = useForm({
    email_address: user.email_address,
    password: '',
    password_confirmation: '',
    role: user.role,
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    put(`/${account.slug}/users/${user.id}`)
  }

  return (
    <Layout account={account} permissions={permissions}>
      <div className="max-w-2xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-[#202020]">Editar Usuario</h1>
          <Link
            href={`/${account.slug}/users`}
            className="text-[#55ACEE] hover:text-[#4a9ad6]"
          >
            Volver
          </Link>
        </div>

        {(validationErrors?.length || formErrors.email_address || formErrors.password || formErrors.role) && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4">
            {validationErrors?.map((error, i) => <p key={i}>{error}</p>)}
            {formErrors.email_address && <p>{formErrors.email_address}</p>}
            {formErrors.password && <p>{formErrors.password}</p>}
            {formErrors.role && <p>{formErrors.role}</p>}
          </div>
        )}

        <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <input
              type="email"
              value={data.email_address}
              onChange={(e) => setData('email_address', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nueva Contraseña (dejar vacío para no cambiar)
            </label>
            <input
              type="password"
              value={data.password}
              onChange={(e) => setData('password', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
              minLength={6}
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Confirmar Nueva Contraseña
            </label>
            <input
              type="password"
              value={data.password_confirmation}
              onChange={(e) => setData('password_confirmation', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
              minLength={6}
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Rol
            </label>
            <select
              value={data.role}
              onChange={(e) => setData('role', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
            >
              {available_roles.map((role) => (
                <option key={role} value={role}>
                  {roleLabels[role] || role}
                </option>
              ))}
            </select>
          </div>

          <button
            type="submit"
            disabled={processing}
            className="w-full bg-[#55ACEE] text-white py-2 rounded-md hover:bg-[#4a9ad6] transition-colors disabled:opacity-50"
          >
            {processing ? 'Guardando...' : 'Guardar Cambios'}
          </button>
        </form>
      </div>
    </Layout>
  )
}
